import { render, staticRenderFns } from "./EventiViewComponent.vue?vue&type=template&id=bebfddfa"
import script from "./EventiViewComponent.vue?vue&type=script&lang=js"
export * from "./EventiViewComponent.vue?vue&type=script&lang=js"
import style0 from "./EventiViewComponent.vue?vue&type=style&index=0&id=bebfddfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports